// North Vale is based on Manchester, UK area
export const NORTH_VALE_CENTER: [number, number] = [-2.2426, 53.4808];
